// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/follow-us-on-instagram-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const followUsOnInstagram2DE: PageEntry = {
  id: "post.follow-us-on-instagram-2",
  locale: "de",
  slug: "follow-us-on-instagram-2",
  seo: {
    title: "Wir feiern den Ausbildungsabschluss unserer Azubis | Dietz GmbH",
    description: "Wir feiern den Ausbildungsabschluss unserer Azubis",
  },
  type: "post",
  h1: "Wir feiern den Ausbildungsabschluss unserer Azubis",
  blocks: [
    { kind: "heading", level: 2, text: "Wir feiern den Ausbildungsabschluss unserer Azubis" },
    { kind: "paragraph", text: "Wir sind sehr stolz auf unsere Azubis, die trotz recht turbulenter und außergewöhnlichen Zeiten in den letzten beiden Jahren ihre Ausbildung in diesem Jahr erfolgreich beendet haben." },
    { kind: "paragraph", text: "In einem gemeinsamen Mittagessen mit unserer Geschäftsführung haben wir die vergangene Ausbildungszeit noch einmal Revue passieren lassen und freuen uns auf die gemeinsame Zeit, die noch vor uns liegt." },
    { kind: "paragraph", text: "Ein besonderer Dank gilt an dieser Stelle unserem Ausbildungsleiter Herrn Michael Wagner, der unsere Azubis tatkräftig unterstützt." },
    { kind: "paragraph", text: "Aktuell haben wir noch für das Jahr 2022 freie Ausbildungsplätze. Wenn auch du Teil der Dietz-Familie werden möchtest um die Zukunft zu gestalten, informiere dich gerne auf der Website." }
  ],
};
